<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6">
        <div class="card">
          <div class="card-body text-center">
              <div class="mb-3">
                <img
                :src="urlImage+form.avatar"
                class="mr-3 rounded-circle avatar-xl"
                alt="user-pic"
                />
              </div>
            <div>
             <b-button class="btn btn-sm" variant="light" @click="editImages(id)"><i class="fas fa-edit"></i> {{ $t('overview.table.all.change-image') }} </b-button>
            </div>
            <div class="pt-4">
                <table class="table-profile table text-left">
                    <thead>
                        <tr>
                            <td width="30%"><b>{{ $t('form.user-management.label.username') }}</b></td>
                            <td width="70%">
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.user-management.placeholder.username')"
                                v-model="form.username"
                                :class="{ 'is-invalid': submitted && $v.form.username.$error }"
                                />
                                <div v-if="submitted && $v.form.username.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.username.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </td>
                        </tr>
                         <tr>
                            <td width="30%"><b>Email</b></td>
                            <td width="70%">
                               <input
                                id="validationCustom01"
                                type="email"
                                class="form-control"
                                :placeholder="$t('form.user-management.placeholder.email')"
                                v-model="form.email"
                                :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                                />
                                <div v-if="submitted && $v.form.email.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.email.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </td>
                        </tr>
                         <tr>
                            <td width="30%"><b>{{ $t('form.user-management.label.user-type') }}</b></td>
                            <td width="70%"><input type="text" class="form-control bg-light" v-model="form.user_type" readonly></td>
                        </tr>
                         <tr>
                            <td width="30%"><b>{{ $t('form.user-management.label.active-until') }}</b></td>
                            <td width="70%"><input type="date" class="form-control bg-light" v-model="form.active_until" readonly></td>
                        </tr>
                       <tr>
                            <td width="30%"><b>{{ $t('table.user-management.th.created-at') }}</b></td>
                            <td width="70%"><input type="text" class="form-control bg-light" :value="formatDate(form.created_at)" readonly></td>
                        </tr>
                        <tr>
                            <td width="30%"><b>{{ $t('table.user-management.th.updated-at') }}</b></td>
                            <td width="70%"><input type="text" class="form-control bg-light" :value="formatDate(form.update_at)" readonly></td>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="text-right mr-2">
               <b-button class="btn" variant="primary" @click="updateUser"> 
                  <span class="d-none d-sm-inline-block">
                    Update
                  </span>
                </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="ref-modal-edit"
      :id="'modal-edit-images'+id"
      centered
      :title="$t('button.update.text')"
      title-class="font-18"
      :ok-title="$t('button.update.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="updateImagesProfile($event, id)"
  >
      <div class="row">
         <div class="col-md-12">
              <div class="form-group text-center">
                  <!-- <img :src="urlimage+form.avatar" class="avatar-xl rounded-circle mr-4"/> -->
              </div>
          </div>
          <div class="col-md-12">
              <div class="form-group">
                  <label for="validationCustom01">{{ $t('overview.table.all.new-image') }} </label>
                    <b-form-file
                        :state="true"
                        :placeholder="$t('overview.table.all.choose')"
                        :drop-placeholder="$t('overview.table.all.drop')"
                        @change="ImageTarget"
                        accept="image/*"
                    ></b-form-file>
              </div>
          </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/user.service";
import { required } from "vuelidate/lib/validators";
import store from '@/state/store';
import moment from 'moment';
import Swal from "sweetalert2";
import Vue from "vue";

/**
 * Profile component
 */
export default {
  page: {
    title: "User Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      title: "User Profile",
      id:'',
      image_avatar:'',
      form:{
        id_user:'',
        username:'',
        email:'',
        user_type:'',
        is_active:'',
        avatar: '',
        active_until:'',
        created_at:'',
        update_at:'',
      },
      submitted: false,
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Profile",
          active: true
        }
      ]
    };
  },
  validations: {
    form: {
        username: { required },
        email: { required },
    },
},
  mounted(){
    this.list();
  },
  methods:{
    list() {
      UserService.getProfile()
      .then(response => {
        this.form = response.data.data
        this.id = response.data.data.id_user
      })
      .catch(e => {
        this.message = e.response.data.data
      });
    },
    ImageTarget(evt){
      this.image_avatar = evt.target.files[0];
    },
    updateImagesProfile(){
      const formImages = new FormData();
      formImages.append('avatar', this.image_avatar, this.image_avatar.name);
        UserService.updateUserAvatar(formImages)
        .then( response => {
            this.list();
            /** update data localstorage user */
            const user = JSON.parse(localStorage.getItem('user'))
            user.avatar = response.data.data.avatar;
            localStorage.setItem('user', JSON.stringify(user));
            /** event to read changes in localstorage user  */
            window.dispatchEvent(new CustomEvent('ava-changed', {
              detail: {
                avatar: response.data.data.avatar
              }
            }));

            Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
            this.$v.$reset();
        })
        .catch(err => {
            console.log(err);
      });
    },
    updateUser(e){
      this.submitted = true;
      this.$v.$touch();
      if (this.form.username == '' || this.form.email == '') {
          e.preventDefault();
      }
      else{
          UserService.updateProfile(this.form)
          .then( response => {
              this.list();
              Vue.swal({
                  position: "top-end",
                  icon: "success",
                  title: response.data.message,
                  showConfirmButton: false,
                  timer: 1500
              });
              this.$v.$reset();
          })
          .catch(err => {
              console.log(err);
          });
      }
    },
    formatDate(value){
      return moment(value).format("YYYY-MM-DD, hh:mm:ss");
    },
    editImages(id){
        this.$bvModal.show('modal-edit-images'+id)
    },
  },
  mounted(){
    this.list();
  }
};
</script>

<style lang="scss" scoped>
.table-profile{
    font-size: 14px;
}
</style>